import { Modal } from 'react-bootstrap';

/**
 * Themed modal wrapper — always applies custom-modal + centered.
 * Use AppModal.Header / .Title / .Body / .Footer in place of Modal.* sub-components.
 */
function AppModal({ children, ...props }) {
  return (
    <Modal className="custom-modal" centered {...props}>
      {children}
    </Modal>
  );
}

AppModal.Header = Modal.Header;
AppModal.Title  = Modal.Title;
AppModal.Body   = Modal.Body;
AppModal.Footer = Modal.Footer;

export { AppModal };
